import styled from "@emotion/styled";
import { Text } from "@otrium/atoms";

export const MobileFiltersContainer = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100dvh;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.tone.white};
  transform: translateX(-100vw);
  transition: transform 350ms ease-in-out;
  z-index: 100000;
  overflow: hidden;

  &.open {
    transform: translateX(0);
  }

  > .content-wrapper {
    display: flex;
    flex-direction: column;
    padding: ${({ theme }) => `0 ${theme.space.space16 || ""}`};
    max-height: 100dvh;
    overflow-y: auto;
  }

  > .close-button {
    display: flex;
    flex-direction: column;
    row-gap: ${({ theme }) => theme.space.space16};
    margin-top: auto;
    padding: ${({ theme }) => theme.space.space16};
    box-shadow: rgba(0, 0, 0, 0.45) 0px 26px 20px 20px;
  }
`;

export const MobileFilterOptionButton = styled.button`
  background-color: transparent;
  border: none;
  padding: ${({ theme }) => theme.space.space16} 0;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.space8};

  > svg:first-of-type {
    width: ${({ theme }) => theme.space.space32};
    height: ${({ theme }) => theme.space.space32};
    flex-shrink: 0;
  }

  &:not(:last-of-type) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.tone.silver};
  }

  svg:last-of-type {
    margin-left: auto;
    flex-shrink: 0;
  }
`;

export const MobileActiveFilters = styled(Text)`
  padding-inline-start: ${({ theme }) => theme.space.space32};
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-grow: 0;
`;
